import * as React from "react";
import DecoratorContext from "./DecoratorContext";
const pipelineFromDecorators = (decorators) => {
  const Component = ({ value, ...rest }) => /* @__PURE__ */ React.createElement(React.Fragment, null, decorators.reduce(
    (prev, Cur) => /* @__PURE__ */ React.createElement(Cur, { ...rest, value }, prev),
    null
  ));
  return Component;
};
const DecoratedValue = (props) => /* @__PURE__ */ React.createElement(DecoratorContext.Consumer, null, (decorators) => {
  const DecoratorPipeline = pipelineFromDecorators(decorators);
  return /* @__PURE__ */ React.createElement(DecoratorPipeline, { ...props });
});
export default DecoratedValue;
